import React, { useState, useCallback, useEffect, useRef, ReactElement } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Button, Collapsible, CollapsibleContainer, Heading, Icon, ToggleSwitch } from "@abb/abb-common-ux-react";
import { ProductContainerColumn, ProductFeature, ProductTitle, SelectedColumn } from "./common/Containers";
import { FooterNavigationButtons } from "./common/FooterNavigationButtons";
import { commonUXTheme } from "styles/commonUXVariables";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Carousel, CarouselItem } from "framework/components/Carousel";



//TODO: F6F6F6 is not in the theme

const FeaturesStep = (): JSX.Element => {
    const { t } = useTranslation();
    const [features, setFeatures] = useState<string[]>([]);

    const onToggleSwitchClick = (e: boolean) => {
        console.log(e)
    }

    useEffect(() => {
        setFeatures(['Advanced HW', 'Advanced COM', 'Distance'])
    }, [])

    return <Box width={"100%"}>
        <Box  textAlign={"center"} mt={commonUXTheme.sizes.m} mb={commonUXTheme.sizes.m} >
            <Heading text={t("Select Features")} showCursor={false} level={3}></Heading>
        </Box>
        <Grid container gap={1}>
            <Grid maxWidth="300px" item xs={12} md={3} minHeight={"200px"}>
                <Heading text={t("Additional features")} showCursor={false} level={4}></Heading>
                <Grid >
                    <CollapsibleContainer
                        singleOpenMode={true}
                        expandOnTitleClick={false}
                    >
                        {features.map((i) => (
                            <Collapsible
                                key={i}
                                itemId={i}
                                title={<Grid spacing={1} width={"100%"} container>
                                    <Grid marginTop={"auto"} marginBottom={"auto"} textAlign="center" item xs >
                                        {i}
                                    </Grid>
                                    <Grid item xs="auto" alignItems={"center"} textAlign="right">
                                        <ToggleSwitch
                                            monochrome={false}
                                            disabled={false}
                                            onChange={onToggleSwitchClick}
                                        />
                                    </Grid>
                                </Grid>}
                            >
                                <div style={{ whiteSpace: "normal" }}>  {i}
                                    Lorem isi o dfndj Fakkst eeaf fsdjk ehuer. Lorem isi o dfndj Fakkst eeaf fsdjk ehuer
                                    Lorem isi o dfndj Fakkst eeaf fsdjk ehuer
                                    Lorem isi o dfndj Fakkst eeaf fsdjk ehuer
                                </div>

                            </Collapsible>
                        ))}
                    </CollapsibleContainer>
                </Grid>
            </Grid>
            <Grid item xs minWidth={"200px"} >
                <Carousel >
                    <CarouselItem>
                        <SelectedColumn>
                            <ProductTitle container alignItems={"center"}>Test Lorem isi o dfndj Fakkst eeaf fsdjk ehuer.</ProductTitle>
                            <ProductFeature $lite={true} container alignItems={"center"}>Test</ProductFeature>
                            <ProductFeature container alignItems={"center"}>Test</ProductFeature>
                            <ProductFeature $lite={true} container alignItems={"center"}>Test</ProductFeature>
                            <ProductFeature container alignItems={"center"}>Test</ProductFeature>
                        </SelectedColumn>
                    </CarouselItem>
                    <CarouselItem>
                        <ProductContainerColumn>
                            <ProductTitle container alignItems={"center"}>Test Lorem isi o dfndj Fakkst eeaf fsdjk ehuer.</ProductTitle>
                            <ProductFeature $lite={true} container alignItems={"center"}>Test</ProductFeature>
                            <ProductFeature container alignItems={"center"}>Test</ProductFeature>
                            <ProductFeature $lite={true} container alignItems={"center"}>Test</ProductFeature>
                            <ProductFeature container alignItems={"center"}>Test</ProductFeature>
                        </ProductContainerColumn>
                    </CarouselItem>
                    <CarouselItem>
                        <ProductContainerColumn>test</ProductContainerColumn>
                    </CarouselItem>
                    <CarouselItem>
                        <ProductContainerColumn>test</ProductContainerColumn>
                    </CarouselItem>
                    <CarouselItem>
                        <ProductContainerColumn>test</ProductContainerColumn>
                    </CarouselItem>
                    <CarouselItem>
                        <ProductContainerColumn>test</ProductContainerColumn>
                    </CarouselItem>
                </Carousel>

            </Grid>
        </Grid>

    </Box>

}

export default FeaturesStep;
